import React from 'react';
import SmallScreenHeaderNav from './SmallScreenHeaderNav';
import LargeScreenHeaderNav from './LargeScreenHeaderNav';

const HeaderNav = () => {
  return (
    <>
      <SmallScreenHeaderNav />
      <LargeScreenHeaderNav />
    </>
  );
};

export default HeaderNav;
